import Harmony from './components/harmony.vue'; 

export const routes = [
	{name: 'harmony', path: '/', component: Harmony},
 	

]; 


// WEBPACK FOOTER //
// ./src/routes.js